import React,{useEffect,useState,useRef} from 'react'
import EmailEditor from 'react-email-editor';
import campaignService from '../../services/campaign.service'

function EmailPreview({id}) {
    const emailEditorRef = useRef(null);
    const [jsonString,setJsonString] = useState(null);
    const onLoad = () => {
        // editor instance is created
        // you can load your template here;
        // const templateJson = {};
        //  emailEditorRef.current.editor.addEventListener(
        //   'design:loaded',
        //   onDesignLoad
        // );
        campaignService.getCampaignById(id)
        .then(res=>{
            const jo = JSON.parse(res.data.jsonContent)
            emailEditorRef.current.editor.loadDesign(jo);
           
        })
      .catch(err=>{
        console.log(err)
      })
      
      };
    
      const onReady = () => {
        // editor is ready
        console.log('onReady');
      };
  return (
    <>
    <p className='text-danger'>Note : This is Preview only. Editing wont save anything.</p>
     <EmailEditor ref={emailEditorRef} onLoad={onLoad} onReady={onReady} style={{height:"80vh"}} />
               
    </>
  )
}

export default EmailPreview